import { render, staticRenderFns } from "./charge-by-oauth-form.vue?vue&type=template&id=22e57fc1"
import script from "./charge-by-oauth-form.vue?vue&type=script&lang=js"
export * from "./charge-by-oauth-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports